import React from 'react';
import PropTypes from 'prop-types';

import { StyledTextFieldContainer } from '../../../../../components/Inputs';
import InputLabel from '../../../../../components/v2/InputLabel';

import texts from './texts.json';
import { StyledPricingTable } from './styles';

const PricingTable = ({ pricing, onPricingChange }) => (
  <StyledTextFieldContainer $withMargin>
    <InputLabel>{texts.title}</InputLabel>
    <StyledPricingTable>
      <thead>
        <tr>
          <th>{texts.headers.month}</th>
          <th>{texts.headers.price}</th>
          <th>{texts.headers.comments}</th>
        </tr>
      </thead>
      <tbody>
        {pricing.map((item, index) => (
          <tr key={item.month}>
            <td>{item.month}</td>
            <td>
              <input
                value={item.price || ''}
                onChange={(e) => onPricingChange(index, 'price', e.target.value)}
                placeholder={texts.placeholders.price}
              />
            </td>
            <td>
              <input
                value={item.comments || ''}
                onChange={(e) => onPricingChange(index, 'comments', e.target.value)}
                placeholder={texts.placeholders.comments}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </StyledPricingTable>
  </StyledTextFieldContainer>
);

PricingTable.propTypes = {
  pricing: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      price: PropTypes.string,
      comments: PropTypes.string,
    }),
  ).isRequired,
  onPricingChange: PropTypes.func.isRequired,
};

export default PricingTable;
